module.exports = __webpack_public_path__ + "static/media/logo.9a6f2d81.svg";